<template>
  <section>
    <div class="row">
      <div class="col-md-12">
        <p>
          If you wish to create messages to your members from a starting point,
          configure a set of canned messages to choose from.
        </p>
      </div>
    </div>
    <message-listing />
  </section>
</template>
<script>
import MessageListing from '@/Components/Users/forms/user-messages-listing'
export default {
  name: 'user-messages',
  components: {
    MessageListing,
  },
}
</script>
<style scoped>
</style>
